/**
 * numberStatusTone.ts — maps a `NumberStatus` (Meta reachability composition)
 * onto the shared `SourceStatus` tone vocabulary so the Number tab reuses
 * `StatusBadge` verbatim (wireframe: "same tone system as StatusBadge") —
 * no new badge component needed.
 *
 * `reachable=false` → unknown (grey) — the Number wireframe's degraded state
 * (N1 AC3). `connected` distinguishes ok (green) / down (red) when reachable;
 * `connected=null` (reachable but no status reported) is `degraded` (amber).
 */

import type { NumberStatus, SourceStatus } from '../../api/types';

export const numberStatusTone = (status: NumberStatus): SourceStatus => {
  if (!status.reachable) return 'unknown';
  if (status.connected === true) return 'ok';
  if (status.connected === false) return 'down';
  return 'degraded';
};
